export default {
  environmentalImpactButton: {
    id: 'rm_modal_impacts_environmental_impact_button',
    defaultMessage: 'Environmental Impact',
  },
  humanImpactButton: {
    id: 'rm_modal_impacts_human_impact_button',
    defaultMessage: 'Human Impact',
  },
  geopoliticalImpactButton: {
    id: 'rm_modal_impacts_geopolitical_impact_button',
    defaultMessage: 'Geopolitical Impact',
  },
} as const
